import NavGlobal from '../../components/navGlobal/navGlobal';
import NavSection from '../../components/navSection/navSection';

import NavSigninLoader from '../../components/account/NavSigninLoader';

 new NavGlobal();
 var navSigninLoader = new NavSigninLoader();
 navSigninLoader.init();

var topLevel = document.querySelector('.section-nav .top-level');
if(null !== topLevel && topLevel !== undefined){
    new NavSection();
}





// WEBPACK FOOTER //
// ./assets/layouts/base/header.js